import { motion } from "framer-motion";

const PHOTOS = [
  { src: "/burger.jpg", alt: "Doppio hamburger con cheddar, bacon e lattuga" },
  { src: "/spine.jpg", alt: "Le spine della birra del pub" },
  { src: "/salsiccia.jpg", alt: "Girello di salsiccia con patatine fritte e piadina" },
  { src: "/tacos.webp", alt: "Tacos francesi con patatine e salse" },
  { src: "/cocktail.jpg", alt: "Cocktail della casa servito al bancone" },
  { src: "/parete.jpg", alt: "La parete delle firme del pub: Tere Tiamo" },
];

export default function Gallery() {
  return (
    <section id="galleria" data-testid="gallery-section" className="py-24 sm:py-32 bg-[#0D0D0F]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs font-mono2 tracking-[0.25em] uppercase text-[#F49D37]"
        >
          Galleria
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mt-4 mb-12"
        >
          Dentro <span className="text-[#D34E36]">Lateresina</span>
        </motion.h2>

        <div className="columns-2 md:columns-3 gap-4">
          {PHOTOS.map((p, i) => (
            <motion.div
              key={p.src}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              data-testid={`gallery-photo-${i}`}
              className="mb-4 break-inside-avoid overflow-hidden rounded-xl border border-[#2A2A34]"
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="w-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
